// extracted by mini-css-extract-plugin
export default {"contents":"zM-z","sectionHeading":"AM-z"};